import { forwardRef } from 'react';
import { TextField, type TextFieldProps } from '@mui/material';

export type Props = TextFieldProps & {};

export const Input = forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { label, required, ...other } = props;

  return <TextField ref={ref} variant='standard' label={`${label || ''}${required ? ' *' : ''}`} fullWidth {...other} />;
});
